import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Copy } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

const SeasonalMenuCopy = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { toast } = useToast();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1f4ed1] to-[#2256e5]">
      {/* Header */}
      <div className="border-b border-white/10 backdrop-blur-sm bg-white/5">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate(`/seasonal-menu/${id}/edit`)}
              className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
              Back to Menu Options
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white/10 backdrop-blur-md rounded-xl border border-white/20 p-8"
        >
          <div className="text-center">
            <div className="p-4 bg-green-400/20 rounded-xl w-fit mx-auto mb-4">
              <Copy className="h-12 w-12 text-green-400" />
            </div>
            <h2 className="text-2xl font-semibold text-white mb-4">Copy from Main Menu - Coming Soon</h2>
            <p className="text-white/60 mb-6">
              Copy items from main menu functionality will be available in Phase 6.
            </p>
            <button
              onClick={() => {
                toast({
                  title: "Coming Soon",
                  description: "Copy from main menu will be implemented in a future phase",
                });
                navigate(`/seasonal-menu/${id}/edit`);
              }}
              className="px-6 py-3 bg-yellow-400 text-gray-900 rounded-lg font-medium hover:bg-yellow-300 transition-all"
            >
              Go Back
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SeasonalMenuCopy;